import React from 'react';
import { Link } from 'react-router-dom';

const StrategicPhilosophy = () => {
  return (
    <section className="relative">
      {/* Header */}
      <div className="bg-cream-100 py-8 md:py-12 text-center px-6">
        <h2
          className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-navy-900 tracking-wide mb-4"
          data-aos="fade-down"
        >
          Strategic Philosophy
        </h2>
        <div className="gold-divider max-w-lg mx-auto" />
      </div>

      {/* Skyline window — transparent */}
      <div className="h-[200px] md:h-[300px] lg:h-[400px]" />

      {/* Dark content */}
      <div className="dark-section py-10 md:py-14 px-6 md:px-12">
        <div className="max-w-3xl mx-auto" data-aos="fade-up">
          <p className="font-body text-base md:text-lg lg:text-xl text-cream-200 leading-relaxed mb-6">
            <span className="font-bold text-white">Marquee</span> serves as
            an independent transaction architect &mdash; focused on
            maximizing enterprise value, improving structural clarity,
            strengthening executive positioning,{' '}
            <span className="font-bold text-white">and enhancing</span>{' '}
            institutional readiness ahead of liquidity events,
            restructurings, or cross-border expansion.
          </p>

          <p className="font-body text-base md:text-lg lg:text-xl text-cream-200 leading-relaxed mb-8">
            The firm leverages{' '}
            <span className="font-bold text-white">over two decades</span>{' '}
            of business development experience and maintains senior-level
            relationships across institutional banking, corporate advisory,
            and executive leadership networks throughout North America and
            Asia.
          </p>

          <div className="text-center mb-10">
            <Link
              to="/contact"
              className="inline-block px-10 md:px-14 py-3 bg-navy-800 text-cream-200 border border-cream-300/40 font-semibold tracking-[0.15em] text-sm hover:bg-navy-900 hover:border-gold-400 hover:text-gold-400 transition-all duration-300"
            >
              CONTACT US
            </Link>
          </div>

          <p className="font-body text-sm md:text-base text-cream-300/60 text-center italic leading-relaxed">
            Marquee operates strictly as an independent corporate advisory
            platform. All regulated securities activity is performed by duly
            licensed third-party professionals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default StrategicPhilosophy;
